export const ROLE_TYPES = [
  'ADMIN',
  'OPERATOR',
  'SUPERVISOR',
  'SALES',
  'RESPONDER',
  'WARDEN',
  'MASTER_ADMIN',
  'LONE_WORKER',
] as const
export type RoleType = (typeof ROLE_TYPES)[number]

export type Role = {
  id: string
  createdDate: string
  description: string
  name: string
  type: RoleType
  updatedDate?: string
}

export function hasRole(roles: Role[], type: RoleType) {
  return roles.some((role) => role.type === type)
}
